import { GET_BOOKING_TRAVELLERS_TOTAL } from "../../store/booking/getter-types";

export default {
  props: {
    id: {
      type: Number,
      required: false,
      default: () => undefined
    },
    selected: {
      type: Boolean,
      required: true,
      default: () => false
    },
    title: {
      type: String,
      required: true,
      default: () => "Component title"
    },
    slug: {
      type: String,
      required: true
    },
    copy: {
      type: String,
      required: true,
      default: () => "Component copy"
    },
    price: {
      type: Number,
      required: true,
      default: () => 0
    },
    isCuatitative: {
      type: Boolean,
      required: false,
      default: () => false
    },
    quantity: {
			type: Number,
			required: false,
			default: () => 0
    },
    counterMaxValue: {
      type: Number,
      required: false,
    },
    counterMinValue: {
      type: Number,
      default: null,
    },
    counterIsDisabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSelected: false,
      dialog: false
    };
  },
  computed: {
    computedSelected: {
      get() {
        return this.isSelected;
      },
      set(value) {
        this.isSelected = value;
      }
    },
    maxValue() {
      if (this.counterMaxValue) {
        return this.counterMaxValue;
      }
      return this.slug === 'transfer' ?
        this.$store.getters[GET_BOOKING_TRAVELLERS_TOTAL]
        : null;
    }
  },
  created() {
    this.computedSelected = this.selected;
  },
  watch: {
    selected: function(value){
      this.isSelected = value;
    }
  },
  methods: {
    moreinfo() {
      alert("more info");
    },
    toggle() {

      this.$emit("checkboxChange");

      if (this.quantity == 0 && this.computedSelected) {
        this.handleCounterChange({ value: 1 });
      }
    },
    handleCounterChange(event) {
      this.$emit("counterChange", event.value, this.id);
    }
  }
};
